module.exports = __webpack_public_path__ + "f5745c3e984e0f1cc268bed7dca3eba2.png";